import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { REQUEST_VENUE_NAMES, EPIC_ERROR } from 'Constants/redux';
import { saveAuthToken } from 'Api';
import service from 'Api/service';
import { receiveVenueNames } from 'Actions';

const fetchVenueNamesEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_VENUE_NAMES),
    debounceTime(500),
    switchMap((action) => {
      const { numberPer: per, query, page } = action.filter;
      return from(
        service.get(`${import.meta.env.VITE_API_DOMAIN}/api/venues/names`, {
          per,
          query,
          page,
        })
      ).pipe(
        map((response) => {
          saveAuthToken(response.headers);
          return receiveVenueNames(response);
        }),
        catchError((error) => {
          console.error('fetchVenueNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default fetchVenueNamesEpic;
